import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { machineCatalogActions } from "../../constants/actionTypes";
import {
  setCatalogListData,
  setCatalogListError,
  deleteCatalogSuccess,
  deleteCatalogError,
  changeCatalogStatusSuccess,
  changeCatalogStatusError,
  createCloneSuccess,
  createCloneError,
  cloneSuccess,
  resetCloneError,
  resetDeleteError,
  successCatalogExport,
  errorCatalogExport,
  successCatalogPlanMapping,
  errorCatalogPlanMapping,
  successUpdateCatalogPlanMap,
  errorUpdateCatalogPlanMap,
  successRetriveCatalogPlanMap,
  errorRetriveCatalogPlanMap,
  successMarkCatalogB2c,
  errorMarkCatalogB2c,
  changeCatalogStatusLoading,
} from "../actions/machineCatalog";
import { setCloudTemplateById, setCloudTemplateByIdError, setCloudTemplates, setCloudTemplatesError } from "../actions/machineCatalogue";
import {
  fetchCatalogsList,
  deleteCatalog,
  changeStatusApi,
  createCloneApi,
  cloneApi,
  listCloudTemplateRequest,
  exportCatalogApi,
  createCatalogPlanMapApi,
  updateCatalogPlanMapApi,
  retriveCatalogPlanMapApi,
  markCatalogForB2cApi,
} from "../api/machineCatalog";
import { toastNotification } from "../../utils/toast";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";

export function* fetchCatalogListFunction({ payload }) {
  try {
    const data = yield call(fetchCatalogsList, payload);
    yield put(setCatalogListData(data));
  } catch (err) {
    console.log(err);
    yield put(setCatalogListError(err));
  }
}

export function* deleteCatalogFunction({ payload }) {
  try {
    const data = yield call(deleteCatalog, payload);
    yield put(resetDeleteError(""));
    if (data.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
      yield put(deleteCatalogSuccess(data));
    } else {
      yield put(deleteCatalogError(data));
    }
  } catch (err) {
    console.log(err);
    yield put(deleteCatalogError(err));
  }
}

export function* changeCatalogStatus({ payload }) {
  try {
    yield put(changeCatalogStatusLoading(true));
    const data = yield call(changeStatusApi, payload);
    yield put(changeCatalogStatusSuccess(data));
    yield put(changeCatalogStatusLoading(false));
  } catch (err) {
    console.log(err);
    yield put(changeCatalogStatusError(err));
  }
}

export function* createCloneFunction({ payload }) {
  try {
    const data = yield call(createCloneApi, payload);
    yield put(resetCloneError(""));
    if (data?.status === statusCode.Ok200) {
      yield put(createCloneSuccess(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      yield put(createCloneError(data?.data?.error && data?.data?.message));
      toastNotification(toasterFlags.WARN, data?.data?.error && data?.data?.message);
    }
  } catch (err) {
    yield put(createCloneError(err));
  }
}

export function* cloneFunction({ payload }) {
  try {
    const data = yield call(cloneApi, payload);
    yield put(resetCloneError(""));
    if (data?.status === statusCode.Created201) {
      yield put(cloneSuccess(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      yield put(createCloneError(data?.data?.error && data?.data?.message));
      toastNotification(toasterFlags.WARN, data?.data?.error && data?.data?.message);
    }
  } catch (err) {
    yield put(createCloneError(err));
  }
}

export function* fetchCloudTemplateListFunction({ payload }) {
  try {
    const data = yield call(listCloudTemplateRequest, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setCloudTemplates(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(setCloudTemplatesError(data));
    }
  } catch (err) {
    yield put(setCloudTemplatesError(err));
  }
}

export function* exportCatalogSkuFunction({ payload }) {
  try {
    const data = yield call(exportCatalogApi, payload);
    if (data?.status === statusCode.BadRequest400) {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorCatalogExport(data));
    } else {
      yield put(successCatalogExport(data));
    }
  } catch (err) {
    yield put(errorCatalogExport(err));
  }
}

export function* createCatalogPlanMapFunction({ payload }) {
  try {
    const data = yield call(createCatalogPlanMapApi, payload);
    if (data?.status === statusCode.Created201) {
      toastNotification(toasterFlags.SUCCESS, "Plans mapped successfully");
      yield put(successCatalogPlanMapping(data));
    } else {
      yield put(errorCatalogPlanMapping(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorCatalogPlanMapping(err));
  }
}

export function* updateCatalogPlanMapFunction({ id, payload }) {
  try {
    const data = yield call(updateCatalogPlanMapApi, id, payload);
    if (data?.status === statusCode.Created201) {
      toastNotification(toasterFlags.SUCCESS, "operation completed successfully");
      yield put(successUpdateCatalogPlanMap(data));
    } else {
      yield put(errorUpdateCatalogPlanMap(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorUpdateCatalogPlanMap(err));
  }
}

export function* retriveCatalogPlanMapFunction({ payload }) {
  try {
    const data = yield call(retriveCatalogPlanMapApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successRetriveCatalogPlanMap(data));
    } else {
      yield put(errorRetriveCatalogPlanMap(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorRetriveCatalogPlanMap(err));
  }
}

export function* markCatalogB2cSaga({ id, payload }) {
  try {
    const data = yield call(markCatalogForB2cApi, id, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successMarkCatalogB2c(data));
    } else {
      yield put(errorMarkCatalogB2c(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorMarkCatalogB2c(err));
  }
}

export function* machineCatalogRootSaga() {
  yield takeLatest(machineCatalogActions.FETCH_CATALOG_LIST_DATA, fetchCatalogListFunction);
  yield takeLatest(machineCatalogActions.DELETE_CATALOG, deleteCatalogFunction);
  yield takeLatest(machineCatalogActions.CHANGE_CATALOG_STATUS, changeCatalogStatus);
  yield takeLatest(machineCatalogActions.CLONE_REQUEST, createCloneFunction);
  yield takeLatest(machineCatalogActions.SET_CLONE_REQUEST, cloneFunction);
  yield takeLatest(machineCatalogActions.FETCH_CLOUD_TEMPLATES, fetchCloudTemplateListFunction);
  yield takeLatest(machineCatalogActions.REQUEST_EXPORT_CATALOG, exportCatalogSkuFunction);
  yield takeLatest(machineCatalogActions.REQUEST_CREATE_CATALOG_PLAN_MAP, createCatalogPlanMapFunction);
  yield takeLatest(machineCatalogActions.REQUEST_UPDATE_CATALOG_PLAN_MAP, updateCatalogPlanMapFunction);
  yield takeLatest(machineCatalogActions.REQUEST_RETRIVE_CATALOG_PLAN_MAP, retriveCatalogPlanMapFunction);
  yield takeLatest(machineCatalogActions.REQUEST_MARKED_CATALOG_B2C, markCatalogB2cSaga);
}

export default function* rootSaga() {
  yield all([fork(machineCatalogRootSaga)]);
}
